import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GenericModal from "@Shared/components/modals/generic-modal.vue";
import ShowSubscriptionLoader from "./show-subscription-loader";
import { LOAD_APPLICATION_SUBSCRIPTION_INFO } from "../../store/application-actions";
import { mapActions } from "vuex";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ShowSubscriptionModal",
  components: {
    ShowSubscriptionLoader,
    GenericModal
  },
  props: {
    clientUsername: {
      type: String,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    },
    subscription: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      table: {
        columns: ["email", "subscribed"],
        options: {
          filterable: false,
          sortable: [],
          perPage: 999999,
          tabbable: false,
          skin: "table mb-0",
          columnsClasses: {
            subscribed: "text-center"
          }
        }
      }
    };
  },
  computed: {
    emailsToShow() {
      var _this$subscription;
      return (_this$subscription = this.subscription) == null ? void 0 : _filterInstanceProperty(_this$subscription).call(_this$subscription, subscription => subscription.email);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [LOAD_APPLICATION_SUBSCRIPTION_INFO])), {}, {
    async handleShow() {
      const {
        clientUsername,
        applicationId,
        agentUsername
      } = this;
      this.loading = true;
      await this.LOAD_APPLICATION_SUBSCRIPTION_INFO({
        clientUsername,
        applicationId,
        agentUsername
      });
      this.loading = false;
    }
  })
});